import React from 'react';

import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    giveOnlinePortalAccess: {
      marginTop: '1.25rem',
      textAlign: 'center',
    },
  };
});

export default ({ onGiveOnlinePortalAccess }) => {
  const classes = useStyles();

  const handleGiveOnlinePortalAccess = (e) => {
    if (onGiveOnlinePortalAccess) onGiveOnlinePortalAccess(e);
  };

  return (
    <Button onClick={handleGiveOnlinePortalAccess} variant="outlined" fullWidth component="span" className={classes.giveOnlinePortalAccess} color="primary">
      Give Mediphany access to online image portal
    </Button>
  );
};
